module.exports = __webpack_public_path__ + "h5/img/zheng.8c339617.png";